import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';
import { BackofficeUser } from 'app/types';

export interface BackofficeState {
  backofficeUser: BackofficeUser | null;
  logged: boolean;
  google_token: string | null;
}

const initialState: BackofficeState = {
  backofficeUser: null,
  logged: false,
  google_token: null,
};

export const backofficeSlice = createSlice({
  name: 'backoffice',
  initialState,
  reducers: {
    loginSuccess: (
      state: BackofficeState,
      action: PayloadAction<{ backofficeUser: BackofficeUser }>
    ) => {
      state.backofficeUser = action.payload.backofficeUser;
      state.logged = true;
    },
    logoutBackofficeUser: (state: BackofficeState) => {
      state.backofficeUser = null;
      state.logged = false;
      state.google_token = null;
    },
  },
});

export const { loginSuccess, logoutBackofficeUser } = backofficeSlice.actions;
export default backofficeSlice.reducer;
